import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useApp } from "@/context/AppContext";
import { MapPin, Clock, Phone, MessageCircle } from "lucide-react";

export default function Contact() {
  const { t } = useApp();
  return (
    <div className="min-h-screen bg-[#FAF7F2] flex flex-col">
      <Header />
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl text-[#1B2A22] mb-8">
          {t("contact_title")}
        </h1>

        <div className="grid lg:grid-cols-2 gap-6">
          <div className="space-y-4">
            {[
              { icon: MapPin, label: t("address_label"), value: "19 Mayıs Caddesi No: 15/A, Yeni Karadağ / Lefke" },
              { icon: Clock, label: t("hours_label"), value: "Her Gün: 08:00 - 24:00 · Paket Servis: 12:00 - 24:00" },
              { icon: Phone, label: t("phone_label"), value: "+90 539 109 57 56" },
            ].map((c, i) => (
              <div
                key={i}
                data-testid={`contact-card-${i}`}
                className="bg-white border border-[#E8E2D5] rounded-2xl p-5 flex gap-4"
              >
                <div className="w-11 h-11 rounded-full bg-[#2E5A36] flex items-center justify-center shrink-0">
                  <c.icon className="w-5 h-5 text-[#E5A024]" />
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-wider font-heading font-bold text-[#2E5A36]">
                    {c.label}
                  </p>
                  <p className="text-[#1B2A22] mt-1">{c.value}</p>
                </div>
              </div>
            ))}

            <a
              data-testid="whatsapp-cta"
              href="https://wa.me/905391095756"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#D9653B] text-white rounded-2xl p-5 flex items-center gap-4 hover:bg-[#B4522F] transition-all"
            >
              <div className="w-11 h-11 rounded-full bg-white/20 flex items-center justify-center shrink-0">
                <MessageCircle className="w-5 h-5" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider font-heading font-bold opacity-90">
                  {t("whatsapp")}
                </p>
                <p className="font-heading font-bold text-lg">
                  Hızlı Sipariş / Fast Order
                </p>
              </div>
            </a>
          </div>

          <div className="rounded-2xl overflow-hidden border border-[#E8E2D5] bg-white h-[400px] lg:h-full min-h-[400px]">
            <iframe
              title="İkizler Market Konum"
              src="https://www.google.com/maps?q=19+Mayıs+Caddesi+No+15+A+Yeni+Karadağ+Lefke&output=embed"
              className="w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
